import { create } from "zustand";
import { devtools } from "zustand/middleware";

type BrandName = string | null;

type ActionState = {
  loading: boolean;
  [key: string]: unknown;
};

export interface BrandDisciplineStore {
  actionState: ActionState;
  selectedBrandName: BrandName;
  selectedDiscipline: string[];

  changeActionState: (patch: Partial<ActionState>) => void;
  setSelectedBrandName: (name: BrandName) => void;
  setSelectedDiscipline: (values: string[]) => void;
  reset: () => void;
}

const initialState: Pick<
  BrandDisciplineStore,
  "actionState" | "selectedBrandName" | "selectedDiscipline"
> = {
  actionState: { loading: false },
  selectedBrandName: null,
  selectedDiscipline: [],
};

export const useBrandDisciplineStore = create<BrandDisciplineStore>()(
  devtools((set) => ({
    ...initialState,

    changeActionState: (patch) =>
      set((s) => ({ actionState: { ...s.actionState, ...patch } })),

    setSelectedBrandName: (name) => set({ selectedBrandName: name }),

    setSelectedDiscipline: (values) => set({ selectedDiscipline: values }),

    reset: () => set({ ...initialState }),
  }))
);
